import './Legal.css';
import SEO from '../../components/SEO/SEO';

function PrivacyPolicy() {
    return (
        <div className='legal_container padding_top padding_bottom'>
            <SEO
                title="Privacy Policy"
                description="Learn how PrepWize collects, uses, and protects your personal information and health data."
                url="https://prepwize.ai/privacy-policy"
            />
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <br />
                    <br />
                    <h2>Privacy Policy</h2>
                    <br />
                    <p className='gray_scale_2 font_size_18'>
                        PrepWize is owned and operated by Revennt, LLC ("we", "us", or "our"). This Privacy Policy explains how we collect, use, and protect your information when you use our app and services, including AI-powered features.
                    </p>

                    <h3>1. Information We Collect</h3>
                    <p>We collect the following types of information when you use PrepWize:</p>
                    <ul>
                        <li><strong>Personal Information:</strong> Name, email address, and login credentials.</li>
                        <li><strong>Health & Dietary Data:</strong> Height, weight, age, dietary restrictions, health goals, and meal preferences.</li>
                        <li><strong>User-Generated Content:</strong> Recipes, notes, images of meals, and messages entered into chat features.</li>
                        <li><strong>Device & Technical Information:</strong> IP address, browser type, operating system, and device identifiers.</li>
                        <li><strong>Usage Data:</strong> Feature interactions, navigation behavior, and session duration.</li>
                    </ul>

                    <h3>2. How We Use Your Information</h3>
                    <p>Your information is used to:</p>
                    <ul>
                        <li>Deliver and personalize meal planning and nutritional guidance</li>
                        <li>Power AI-driven features like meal recognition and chat-based coaching</li>
                        <li>Analyze user behavior to improve functionality and performance</li>
                        <li>Send you important updates, service notifications, and marketing emails (opt-out available)</li>
                        <li>Protect against fraud and ensure the security of our systems</li>
                        <li>Comply with legal obligations</li>
                    </ul>

                    <h3>3. AI Feature-Specific Data Use</h3>
                    <p>
                        Certain features of PrepWize involve artificial intelligence (AI), including meal recognition from uploaded images and chat-based assistance. Your images and chat inputs may be processed using AI models (internal or third-party) for the purpose of generating personalized responses and recommendations. This data is not used to train publicly available models, and we do not sell this information to third parties.
                    </p>

                    <h3>4. Sharing Your Information</h3>
                    <p>We do not sell your personal data. We may share it only with:</p>
                    <ul>
                        <li>Trusted third-party service providers (e.g., hosting, cloud processing, analytics)</li>
                        <li>Legal authorities, if required to comply with applicable law, regulation, or legal process</li>
                        <li>Other parties with your explicit consent</li>
                    </ul>

                    <h3>5. Data Retention</h3>
                    <p>
                        We retain your data only as long as needed for the purposes described in this policy or as required by law. You may request deletion of your data at any time by contacting us.
                    </p>

                    <h3>6. Your Rights</h3>
                    <p>Depending on your jurisdiction, you may have rights including:</p>
                    <ul>
                        <li>Accessing your personal data</li>
                        <li>Correcting or updating inaccurate information</li>
                        <li>Requesting deletion of your account and data</li>
                        <li>Objecting to certain types of data processing</li>
                    </ul>
                    <p>
                        To exercise your rights, contact us at <a href="mailto:support@prepwize.ai">support@prepwize.ai</a>.
                    </p>

                    <h3>7. Security</h3>
                    <p>
                        We implement commercially reasonable safeguards to protect your data, including encryption, access controls, and secure infrastructure. However, no system is entirely secure. You are responsible for keeping your login information confidential and using strong, unique passwords.
                    </p>

                    <h3>8. Children’s Privacy</h3>
                    <p>
                        PrepWize is not intended for children under 13. We do not knowingly collect personal data from minors. If we become aware that we have collected such data, we will delete it promptly.
                    </p>

                    <h3>9. Changes to This Policy</h3>
                    <p>
                        We may update this Privacy Policy to reflect changes in our practices or legal requirements. Any changes will be posted on this page with an updated "Effective Date." Your continued use of the service constitutes acceptance of any modifications.
                    </p>

                    <h3>10. Contact Us</h3>
                    <p>
                        If you have any questions about this Privacy Policy or your data, please contact us at: <a href="mailto:support@prepwize.ai">support@prepwize.ai</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
